import { GridColDef } from '@mui/x-data-grid';

export interface ITableHeadersConfig {
  ALL_USERS_LIST: GridColDef[];
  USER_ROLE_LISTING: GridColDef[];
  ALL_ROLES_LIST: GridColDef[];
  ALL_USERS_BY_ROLE: GridColDef[];
  ALL_API_CONFIG_LIST: GridColDef[];
  ALL_POLICY_LIST: GridColDef[];
  ALL_APP_LEVEL_CREDENTIALS_URLS_LIST: GridColDef[];
}

const TableHeadersConfig: ITableHeadersConfig = {
  ALL_USERS_LIST: [
    {
      field: 'name',
      headerName: 'User name',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'email_id',
      headerName: 'Email ID',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 100
    },
    {
      field: 'mobile',
      headerName: 'Phone number',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 100
    },
    // {
    //   field: 'user_key',
    //   headerName: 'User ID',
    //   sortable: false,
    //   filterable: false,
    //   flex: 1,
    //   minWidth: 100
    // },
    {
      field: 'user_type',
      headerName: 'User type',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 100
    },
    {
      field: 'organizations',
      headerName: 'Organization',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 100
    },
    {
      field: 'business_units',
      headerName: 'BU tagging',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 100
    }
  ],
  USER_ROLE_LISTING: [
    {
      field: 'organization_label',
      headerName: 'Organization',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 200,
      maxWidth: 200
    },
    {
      field: 'application_label',
      headerName: 'Application',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 200,
      maxWidth: 200
    },
    {
      field: 'parent_roles',
      headerName: 'Parent role',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 200,
      maxWidth: 200
    },
    {
      field: 'role_name',
      headerName: 'Role name',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 300,
      maxWidth: 300
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      sortable: false,
      filterable: false,
      flex: 1,
      minWidth: 500
    }
  ],
  ALL_ROLES_LIST: [
    {
      field: 'application_label',
      headerName: 'Application',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'ui_label',
      headerName: 'Role name',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'child_roles',
      headerName: 'Child role names',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'child_permissions',
      headerName: 'Child permissions',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    }
  ],
  ALL_USERS_BY_ROLE: [
    {
      field: 'name',
      headerName: 'User name',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'email_id',
      headerName: 'Email ID',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'mobile',
      headerName: 'Phone number',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'user_key',
      headerName: 'User key',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'user_type',
      headerName: 'User type',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'organization',
      headerName: 'Organization',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    },
    {
      field: 'bu_tagging',
      headerName: 'BU tagging',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 150
    }
  ],
  ALL_API_CONFIG_LIST: [
    {
      field: 'name',
      headerName: 'Name',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 200
    },
    {
      field: 'method',
      headerName: 'HTTP method',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 80
    },
    {
      field: 'uri',
      headerName: 'URI',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 300
    },
    {
      field: 'version',
      headerName: 'Version',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 50
    },
    {
      field: 'is_authorized',
      headerName: 'Is authorized',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 80
    },
    {
      field: 'preview_mode',
      headerName: 'Preview mode',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 80
    },
    {
      field: 'permissions',
      headerName: 'Permissions',
      sortable: false,
      filterable: true,
      flex: 1,
      minWidth: 300
    }
  ],
  ALL_POLICY_LIST: [
    {
      field: 'policy_key',
      headerName: 'Policy Key',
      flex: 1,
      minWidth: 250,
      sortable: false,
      filterable: false
    },
    {
      field: 'policy_name',
      headerName: 'Policy Name',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filterable: true
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false
    },
    {
      field: 'version',
      headerName: 'Version',
      flex: 0.5,
      minWidth: 100,
      sortable: true,
      filterable: false,
      type: 'number'
    }
  ],
  ALL_APP_LEVEL_CREDENTIALS_URLS_LIST: [
    {
      field: 'source_application',
      headerName: 'Source Application',
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false
    },
    {
      field: 'destination_application',
      headerName: 'Destination Application',
      flex: 1,
      minWidth: 200,
      sortable: false,
      filterable: false
    },
    {
      field: 'roles',
      headerName: 'Roles',
      flex: 1,
      minWidth: 200,
      sortable: true,
      filterable: true
    },
    {
      field: 'client_id',
      headerName: 'Client Id',
      flex: 1,
      minWidth: 250,
      sortable: false,
      filterable: false
    },
    {
      field: 'expiry_time',
      headerName: 'Expiry Time',
      flex: 1,
      minWidth: 150,
      sortable: true,
      filterable: false
    },
    {
      field: 'version',
      headerName: 'Version',
      flex: 1,
      minWidth: 50,
      sortable: true,
      filterable: false
    }
  ]
};

export default TableHeadersConfig;
